module.exports = __webpack_public_path__ + "img/logo5.17a74b07.png";